export const ME_CONTROL_CONTAINER_ID = 'me-control-container';
export const ME_CONTROL_FALLBACK_ID = 'me-control-fallback';
export const ME_CONTROL_DOM_ID = 'mectrl_main_trigger';
export const ME_CONTROL_MAIN_BODY_ID = 'mectrl_main_body';
export const ME_CONTROL_ACCOUNT_LIST_NAME = '.mectrl_accountList';
export const ME_CONTROL_TRUNCATE_NAME = 'mectrl_truncate';
export const ME_CONTROL_ACCOUNT_ITEM_CLASS = 'mectrl_accountItem';
export const ME_CONTROL_ACCOUNT_ITEM_INFO = 'mectrl_accountItemInfo';
export const ME_CONTROL_GMAIL_ICON = 'mectrl_addGmailAccount_picture';
export const ME_CONTROL_ACCOUNT_ITEM_CONTAINER_ID = 'me-control-account-item-container';
